export const vrboApprovalStatus = {
  new: 'new',
  reject: 'reject',
  approved: 'approved',
} as const;

export type VrboApprovalStatus = (typeof vrboApprovalStatus)[keyof typeof vrboApprovalStatus];

export const airbnbApprovalStatus = {
  new: 'new',
  rejected: 'rejected',
  approved: 'approved',
  readyForReview: 'ready for review',
} as const;

export type AirbnbApprovalStatus = (typeof airbnbApprovalStatus)[keyof typeof airbnbApprovalStatus];

export interface ListingChannelInfoDto<T> {
  approval_status: T | null;
  approval_status_note: string | null;
}

export interface ListingChannelInfo<T> {
  approvalStatus: T | null;
  approvalStatusNote: string | null;
}

export const convertListingChannelInfoFromDto = <T>(
  data: ListingChannelInfoDto<T>,
): ListingChannelInfo<T> => ({
  approvalStatus: data.approval_status,
  approvalStatusNote: data.approval_status_note,
});
